class CreateOrUpdateCustomerAgentResult {
    Id: number;
    Token: string;

    constructor(id: number, token: string) {
        this.Id = id;
        this.Token = token;
    }
}

export default CreateOrUpdateCustomerAgentResult;
